var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorporateOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(678 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.25,10V3H6.5V6.5H3V18.75h7v-3.5h1.75v3.5h7V10ZM6.5,17H4.75V15.25H6.5Zm0-3.5H4.75V11.75H6.5Zm0-3.5H4.75V8.25H6.5ZM10,13.5H8.25V11.75H10ZM10,10H8.25V8.25H10Zm0-3.5H8.25V4.75H10Zm3.5,7H11.75V11.75H13.5Zm0-3.5H11.75V8.25H13.5Zm0-3.5H11.75V4.75H13.5ZM17,17H15.25V15.25H17Zm0-3.5H15.25V11.75H17Z",
    transform: "translate(676 8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateOn);
export default __webpack_public_path__ + "static/media/icon_corporate_on.b6638f102bc7455d7335c38476921efc.svg";
export { ForwardRef as ReactComponent };